var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 26,
    viewBox: "0 0 15 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path 10452",
    d: "M1.19184 12.7645L14.1038 1.15553C14.3608 0.871534 14.4788 0.987534 14.3658 1.41353L9.05384 12.5065C8.94045 13.0139 8.94045 13.5401 9.05384 14.0475L14.3628 24.9785C14.4768 25.4035 14.3628 25.5205 14.1008 25.2395L1.19484 13.7865C1.06985 13.6458 1.00056 13.4643 1.00001 13.2761C0.99946 13.0879 1.06768 12.906 1.19184 12.7645Z",
    fill: "#1B224C",
    stroke: "#1B224C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToLeft);
export default __webpack_public_path__ + "static/media/toLeft.d870587533899899ea303be4d7f5c102.svg";
export { ForwardRef as ReactComponent };